import { NgModule, Optional, SkipSelf } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { ModalModule } from 'ngx-modialog-11';
import { BootstrapModalModule } from 'ngx-modialog-11/plugins/bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { CommonFeatureModule } from '@app/common-feature';
import { throwIfAlreadyLoaded } from './module-import-guard';
import { MessageBoxComponent } from './dialogs/message-box/message-box.component';
import { FormsComponent } from './dialogs/forms/forms.component';
import { PdfDownloadComponent } from './dialogs/pdf-download/pdf-download.component';
import { AppearanceComponent } from './dialogs/appearance/appearance.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { ErrorComponent } from './components/error/error.component';
import { FinishPageComponent } from './components/finish-page/finish-page.component';
import { SessionTimedOutPageComponent } from './components/session-timed-out-page/session-timed-out-page.component';
import { PackageErrorComponent } from './components/package-error/package-error.component';
import { DrawCanvasComponent } from './components/draw-canvas/draw-canvas.component';
import { ImageUploadComponent } from './components/image-upload/image-upload.component';
import { ColorPickerComponent } from '@app/core/components/color-picker/color-picker.component';
import { SignatureAndInitialTypeComponent } from '@app/core/components/signature-and-initial-type/signature-and-initial-type.component';
import { ReactiveFormsModule } from '@angular/forms';
import { DeviceDetectorModule } from 'ngx-device-detector';

@NgModule({
  imports: [
    BrowserModule,
    HttpClientModule,
    TranslateModule,
    ModalModule.forRoot(),
    DeviceDetectorModule.forRoot(),
    BootstrapModalModule,
    CommonFeatureModule,
    ReactiveFormsModule,
  ],
  declarations: [
    MessageBoxComponent,
    FormsComponent,
    PdfDownloadComponent,
    PageNotFoundComponent,
    ErrorComponent,
    FinishPageComponent,
    SessionTimedOutPageComponent,
    PackageErrorComponent,
    AppearanceComponent,
    DrawCanvasComponent,
    ImageUploadComponent,
    ColorPickerComponent,
    SignatureAndInitialTypeComponent,
  ],
  entryComponents: [MessageBoxComponent, FormsComponent, PdfDownloadComponent, AppearanceComponent],
  exports: [TranslateModule],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
